export default "__VITE_ASSET__C4Ae7pmb__"